import { ReactNode, useMemo, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { PublisherResource } from '~/generated';
import { usePublisherSearch } from '~/hooks/api/usePublisherSearch';

export const getFullNameForPublisher = (publisher?: Publisher) =>
  publisher ? `${publisher.firstName} ${publisher.lastName}` : '';

type Publisher = Pick<PublisherResource, 'id' | 'firstName' | 'lastName'>;

type UserAutocompleteFieldProps = {
  label: ReactNode;
  input: {
    value?: Publisher;
    onChange: (value: Publisher | null, resetInputValue: () => void) => void;
  };
  getOptionLabel?: (option: {
    id: number;
    firstName: string;
    lastName: string;
  }) => string;
  getOptionDisabled?: (option: {
    id: number;
    firstName: string;
    lastName: string;
  }) => boolean;
};
const UserAutocompleteField = (props: UserAutocompleteFieldProps) => {
  const [inputValue, setInputValue] = useState(
    getFullNameForPublisher(props.input.value)
  );
  const { data: publishers } = usePublisherSearch(
    inputValue,
    [],
    [],
    ['firstName']
  );
  const options = publishers?.map((publisher) => ({
    id: publisher.id,
    firstName: publisher.firstName,
    lastName: publisher.lastName,
  }));
  const value = useMemo(
    () =>
      props.input.value
        ? {
            id: props.input.value.id,
            firstName: props.input.value.firstName,
            lastName: props.input.value.lastName,
          }
        : null,
    [props.input.value]
  );
  return (
    <Autocomplete
      getOptionDisabled={props.getOptionDisabled}
      filterOptions={(x) => x}
      disablePortal
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={value}
      id="language-autocomplete-field"
      options={options || []}
      onChange={(_event, newValue) => {
        props.input.onChange(newValue, () => setInputValue(''));
      }}
      getOptionLabel={props.getOptionLabel || getFullNameForPublisher}
      renderInput={(params) => <TextField {...params} label={props.label} />}
      inputValue={inputValue}
      onInputChange={(_event, newInputValue) => {
        setInputValue(newInputValue);
      }}
    />
  );
};

export default UserAutocompleteField;
